import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../actions/usersActions';
import * as constant from '../../constants/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class VerifyUser extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			userName: '',
			image: '',
			userPassword: '',
			passwordData: 0
		}
		this.verifyPassword = this.verifyPassword.bind(this)
		this.patientPassword = this.patientPassword.bind(this)
	}

	componentWillMount() {
		let userData = JSON.parse(localStorage.getItem('user'))
		this.setState({ userName: userData.userName, image: userData.image })
	}

	componentDidMount() {
	}

	componentWillReceiveProps(nextProps) {
		console.log("==>>>...VERIFYPROPS", nextProps)
		if (nextProps.passwordData && nextProps.passwordData > 0) {
			this.props.history.push('/dashboard/my-health-record')
			localStorage.setItem('passwordData', nextProps.passwordData)

		}
	}

	verifyPassword() {
		// debugger
		var passwordObj = {
			password: this.state.userPassword,
			userId: localStorage.getItem('userId')

		}

		this.props.actions.verifyPassword(passwordObj)

	}

	patientPassword(event) {

		this.setState({
			userPassword: event.target.value
		})
	}

	render() {
		let image = this.state.image;
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png';
		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					{/* <div className="row">
						<div className="col-md-5">
							<div className="boxMrgB">
								<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/family_medicine.png')} alt="" /></i></span>
									<input type="" className="form-control" placeholder="Family Medicine" />
								</div>
							</div>
						</div>
						<div className="col-md-5">
							<div className="boxMrgB">
								<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/map_icon.png')} alt="" /></i></span>
									<input type="" className="form-control" placeholder="Family Medicine" />
								</div>
							</div>
						</div>
						<div className="col-md-2">
							<div className="boxMrgB searchBtn">
								<button type="button" className="btn btn-block btn-warning btn-lg"><i className="fa fa-search"></i><span>Search</span></button>
							</div>
						</div>
					</div> */}
					<ToastContainer />
					<div className="row">
						<div className="col-md-12 verify_ipad-spacing">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" data-toggle="tab" className="active show">My Health Records</Link></li>
									</ul>


									<div className="tab-content">
										<div className="tab-pane active" id="tab_1">

											<div className="settingInput">
												<div className="row">
													<div className="col-md-12">
														<div className="userProImgHelth">
															<p className="passwordText"> Please re-enter your password to access<br />Your health records.</p>

															{image == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'} alt="User profile picture" /> : <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + image} alt="User profile picture" onError={e => {
																e.target.src = defaultImagePath;
															}} />}

															< h2 ><p className="text-capitalize"> {this.state.userName ? this.state.userName : ''}</p></h2>
														</div>
													</div>
													<div className="col-md-12 text-center">

														<div className="boxMrgB inputbtntabletwidth">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" className="form-control" placeholder="Enter Password" onChange={this.patientPassword.bind(this)} autoComplete="off" />
															</div>
														</div>

														{/* <Link href="#" className="passwordLink">Forgot Password?</Link> */}
													</div>
													<div className="col-md-12 text-center">
														<div className="boxMrgB btnBtm">
															<button type="button" className="btn btn-warning btn-lg btnBtm190" onClick={this.verifyPassword.bind(this)}>Go</button>
														</div>
													</div>
												</div>
											</div>


										</div>
									</div>


								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		passwordData: state.users.passwordData
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(usersActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(VerifyUser);